module.exports = __webpack_public_path__ + "static/media/catmoji.180cff77.png";